import React, { Component } from "react"
import { connect } from "react-redux"

import { COLOR, COOKIES, PATH } from "../../modules/constants"
import history from "../../services/history"

import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import Button from "@mui/material/Button"
import { withStyles } from "@mui/styles"

const styles = () => ({
  text: {
    color: "black",
    whiteSpace: "pre-wrap",
  },
  link: {
    color: COLOR.BRAND.STD,
    textDecoration: "underline",
    cursor: "pointer",
  }
})

const CHECK_COOKIE = true

class The350ClubIntroModal extends Component {

  cookieIsSet = () => document.cookie.includes(COOKIES.NO_350_CLUB_MODAL_COOKIE)

  render() {
    const { classes, open, onClose, loading } = this.props

    const hrefHome = "https://www.numerable.io/?utm_source=350club&utm_medium=numapp&utm_campaign=intromodal"
    const hrefContact = "https://www.numerable.io/contact/?utm_source=350club&utm_medium=numapp&utm_campaign=intromodal"

    // console.log("this.cookieIsSet():", this.cookieIsSet())

    if (CHECK_COOKIE && this.cookieIsSet()) {
      // console.log(`${COOKIES.NO_350_CLUB_MODAL_COOKIE} has been set`)
      return null
    }

    return (
      <React.Fragment>

        <Dialog
          disableRestoreFocus={true}
          open={Boolean(open)}
          // onClose={onClose}
          maxWidth="sm" fullWidth>

          <DialogTitle>Welcome to Numerable</DialogTitle>

          <DialogContent>
            <DialogContentText className={classes.text}>Numerable is an enterprise search and relationship mapping system for FTSE and AIM companies and directors.</DialogContentText>

            <DialogContentText className={classes.text}>Developed by <a href={hrefHome} target="_blank" rel="noopener noreferrer" className={classes.link} >Numerable Software Ltd</a>, it is partnering with The 350 Club to offer Numerable free to members.</DialogContentText>

            <DialogContentText className={classes.text}>Our information updates daily and we do our utmost to ensure the quality of our data, however it is not possible to guarantee 100% accuracy.</DialogContentText>

            <DialogContentText className={classes.text}>Commercial subscriptions are available - learn more at <a href={hrefHome} target="_blank" rel="noopener noreferrer" className={classes.link} >numerable.io</a> or <a href={hrefContact} target="_blank" rel="noopener noreferrer" className={classes.link} >contact us</a>.</DialogContentText>

            <DialogContentText className={classes.text}>We use cookies to give the best experience on our web system. By continuing to use this system you are indicating agreement with our <span onClick={() => history.push(`/${PATH.T_AND_C}`)} className={classes.link} >Terms and Conditions</span> and <span onClick={() => history.push(`/${PATH.PRIVACY}`)} className={classes.link} >Privacy Policy</span></DialogContentText>

          </DialogContent>

          <DialogActions>
            {/* <Button
              disabled={loading}
              color="primary"
              onClick={() => { history.push("https://the350.club/") }}
              style={{ marginRight:"auto" }}
              >
              Go back to 350 Club
            </Button> */}

            <Button
              disabled={loading}
              onClick={onClose}
              variant="contained"
              color="primary"
            >
              Agree and continue to Numerable
            </Button>

          </DialogActions>

        </Dialog>
      </React.Fragment>
    )
  }
}

// @ts-ignore
export default connect()(withStyles(styles)(The350ClubIntroModal))


